module.exports = __webpack_public_path__ + "img/security1.3e7db4df.svg";